module.exports = __webpack_public_path__ + "img/fr_fr.1c0155a8.png";